export default __webpack_public_path__ + "static/media/Social Links.c8066c22.svg";